import { WarningIcon } from "../../asset/image";
import { useTranslation } from "../../lib";
import { useSelectTheme } from "../../store";

export interface RateLimitNoticeProps {
  /** the whole seconds the 429's Retry-After asked for */
  waitSeconds: number;
  className?: string;
}

/**
 * What a page says after a 429, in place of an error about the input. The number is the wait as
 * the server gave it and does not count down, so the live region announces it once.
 */
export const RateLimitNotice = ({ waitSeconds, className }: RateLimitNoticeProps) => {
  const { t } = useTranslation();
  const { color } = useSelectTheme();

  return (
    <div
      data-testid="rate_limit_notice"
      role="status"
      aria-live="polite"
      className={className}
      css={{ display: "flex", alignItems: "flex-start" }}
    >
      <img src={WarningIcon} width="20" css={{ flex: "none", marginTop: "2px" }} />
      <span css={{ marginLeft: "8px", color: color.warning }}>
        {t("rate_limit.wait_message", { count: waitSeconds })}
      </span>
    </div>
  );
};
